module.exports = {
      id: "icon-twitter-usage",
      viewBox: "0 0 19.798 20.251",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#icon-twitter",
      toString: function () {
        return this.url;
      }
    }